/**
 * @module interface
 */
export interface V2TimGroupAtInfo {
    seq: string;
    atType: number;
}
